function cleanName(value) {
  if (value == null) return '';
  const name = String(value).trim();
  if (!name) return '';
  const lowered = name.toLowerCase();
  if (lowered === 'null' || lowered === 'undefined') return '';
  return name;
}

function positiveNumber(value) {
  const num = Number(value);
  return Number.isFinite(num) && num > 0 ? num : null;
}

function readLocalStorage(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function readStoredSession() {
  try {
    const raw = localStorage.getItem('session');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function firstName(...values) {
  for (const value of values) {
    const name = cleanName(value);
    if (name) return name;
  }
  return '';
}

export function normalizeCustomerName(value) {
  return cleanName(value);
}

export function resolveActiveCustomerContext(session) {
  const storedSession = readStoredSession();

  const selectedCustomerId = positiveNumber(readLocalStorage('selectedCustomerId'));
  const localCustomerId = positiveNumber(readLocalStorage('customerId'));
  const sessionCustomerId = positiveNumber(
    session?.customerId ?? session?.customer_id ?? session?.customer_id_fk ?? session?.custid
  );
  const storedSessionCustomerId = positiveNumber(
    storedSession?.customerId ??
      storedSession?.customer_id ??
      storedSession?.customer_id_fk ??
      storedSession?.custid
  );

  const customerId =
    selectedCustomerId || sessionCustomerId || storedSessionCustomerId || localCustomerId;

  if (!customerId) {
    return { customerId: null, customerName: '' };
  }

  const sessionName = firstName(session?.customerName, session?.customer_name);
  const storedSessionName = firstName(
    storedSession?.customerName,
    storedSession?.customer_name
  );
  const localName = firstName(readLocalStorage('customerName'));

  if (selectedCustomerId) {
    return {
      customerId: selectedCustomerId,
      customerName: firstName(
        localName,
        storedSessionCustomerId === selectedCustomerId ? storedSessionName : '',
        sessionCustomerId === selectedCustomerId ? sessionName : ''
      ),
    };
  }

  if (sessionCustomerId) {
    return {
      customerId: sessionCustomerId,
      customerName: firstName(
        sessionName,
        storedSessionCustomerId === sessionCustomerId ? storedSessionName : '',
        localCustomerId === sessionCustomerId ? localName : ''
      ),
    };
  }

  if (storedSessionCustomerId) {
    return {
      customerId: storedSessionCustomerId,
      customerName: firstName(
        storedSessionName,
        localCustomerId === storedSessionCustomerId ? localName : ''
      ),
    };
  }

  return {
    customerId: localCustomerId,
    customerName: localCustomerId ? localName : '',
  };
}
